<template>
	<div class="page-content__content">
		<div class="stats">
			<StatsFilter/>
			<StatsHead :supplier-blocks="getSupplierBlocks"/>
			<StatsTable :stats-data="getSupplierList"/>
			<div class="pagination" v-if="getSupplierPagination.total > getSupplierPagination.limit">
				<vue-awesome-paginate
					:total-items="getSupplierPagination.total"
					:items-per-page="getSupplierPagination.limit"
					:max-pages-shown="3"
					v-model="curPage"
				/>
			</div>
		</div>
	</div>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { provide } from 'vue';
import StatsFilter from "@/components/sections/Stats/StatsFilter.vue";
import StatsHead from "@/components/sections/Stats/StatsHead.vue";
import StatsTable from "@/components/sections/Stats/StatsTable.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";

export default {
	name: "StatsPage",
	components: {StatsFilter,StatsHead, StatsTable, PageLoader},
	props: {
		legal: {
			type: Array,
			default: () => []
		},
	},
	setup(props) {
		provide('legal', props.legal)
	},

	async created() {
		await this.requestStatistics();
	},
	computed: {
		curPage: {
			get() {
				return Math.round(this.getSupplierPagination.offset / this.getSupplierPagination.limit) + 1
			},
			set(value) {
				this.updatePagination({offset: (value - 1) * this.getSupplierPagination.limit})
			}
		},
		...mapGetters({
			getSupplierBlocks: 'stats/getSupplierBlocks',
			getSupplierList: 'stats/getSupplierList',
			getSupplierPagination: 'stats/getSupplierPagination',
			isLoading: 'isLoading',
		})
	},
	methods: {
		...mapActions({
			requestStatistics: 'stats/requestStatistics',
			updatePagination: 'stats/updatePagination',
		})
	}
}
</script>


